import {useEffect} from 'react';
import store from '../../redux/store';
import {getGameAnalytics, isGameAnalyticsInitialized} from '../../analytics/gameAnalytics';
import {trackAdPageView} from '../../analytics/adTracking';

/**
 * Аналитика экрана: событие в GameAnalytics и виртуальный просмотр страницы в
 * рекламных счетчиках (VK Реклама и Яндекс Метрика — см. adTracking).
 * Настоящий просмотр в SPA случается один раз за загрузку, поэтому смену
 * экранов счетчики видят только отсюда.
 *
 * Id игрока читается прямо из стора, а не через useSelector: хук зовут 40+
 * страниц (в том числе в тестах без Provider), и подписка на стор ради одной
 * метки в уже отправляемом событии им не нужна
 */
export const usePageAnalytics = (pageId) => {
  useEffect(() => {
    trackAdPageView(pageId, store.getState()?.private?.auth?.id);

    if (!isGameAnalyticsInitialized()) {
      return;
    }
    try {
      getGameAnalytics().addDesignEvent(`page:${pageId}:mount`);
    } catch (error) {
      console.error(`[usePageAnalytics] Failed to send event for ${pageId}:`, error);
    }
  }, [pageId]);
};
